<template>
    <el-select
      remote
      v-if="valueKey !== 'item'"
      :remote-method="onInput"
      v-model="selectedValue"
      filterable
      clearable
      :disabled="isDisabled"
      :placeholder="placeholder"
      @clear="handleClear"
      @change="handleChange"
    >
      <el-option
        v-for="item in filteredOptions"
        :key="item[valueKey]"
        :label="item[labelKey]"
        :value="item[valueKey]"
      />
      <el-option v-if="filteredOptions.length === 0" label="" value="" />
    </el-select>
    <el-select
      remote
      v-else
      :remote-method="onInput"
      v-model="selectedValue"
      filterable
      clearable
      :disabled="isDisabled"
      :placeholder="placeholder"
      @clear="handleClear"
      @change="handleChange"
    >
      <el-option
        v-for="item in filteredOptions"
        :key="item[labelKey]"
        :label="item[labelKey]"
        :value="item"
      />
      <el-option v-if="filteredOptions.length === 0" label="" value="" />
    </el-select>
  </template>
    
    <script>
  export default {
    name: "CustomSelect",
    props: {
      options: {
        type: Array,
        required: true,
      },
      labelKey: {
        type: String,
        default: "label",
      },
      valueKey: {
        type: String,
        default: "value",
      },
      placeholder: {
        type: String,
        default: "请选择",
      },
      modelValue: {
        type: String,
        default: "",
      },
      modelValue: {
        type: String,
        default: "",
      },
      isDisabled: {
        type: Boolean,
        default: false, // 默认不禁用
      },
    },
    data() {
      return {
        selectedValue: this.modelValue,
        filteredOptions: [],
      };
    },
    watch: {
      modelValue(newValue) {
        this.selectedValue = newValue;
      },
      options: {
        immediate: true,
        handler(newOptions) {
          this.filteredOptions = newOptions.slice(0, 30); // 初始显示前30个
        },
      },
    },
    methods: {
      onInput(value) {
        // 进行模糊查询
        this.filteredOptions = this.options
          .filter((item) =>
            item[this.labelKey].toLowerCase().includes(value.toLowerCase())
          )
          .slice(0, 30); // 显示前30个匹配项
      },
      handleChange(value) {
        console.log("返回值", value);
        this.$emit("input", value); // 发射 input 事件
      },
      handleClear() {
        this.$emit("input", ""); // 清除时返回空值
        this.filteredOptions = this.options.slice(0, 30);
      },
    },
  };
  </script>
    
    <style scoped>
  /* 可添加样式 */
  .custom-select .el-select ::v-deep .el-input__inner {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    max-width: 200px !important; /* 根据需要调整 */
  }
  
  .custom-select .el-option {
    white-space: nowrap;
  }
  </style>
  <!-- <custom-select
  v-model="merchandiseName"
  :options="merchandiseNameData"
  label-key="value"
  value-key="value"
  placeholder="请选择商品"
  /> -->
  <!-- <custom-select
  v-model="warehouseName"
  :options="warehouseNameData"
  label-key="value"
  value-key="value"
  placeholder="请选择仓库"
  /> -->
  <!-- import CustomSelect from '@/components/CustomSelect'; -->
  <!-- components: {
      CustomSelect
    }, -->